export default "__VITE_ASSET__0a1ae4b3__"